/*
 * LinkSettings Messages
 *
 * This contains all the text for the LinkSettings container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.LinkSettings.endPage';

export default defineMessages({
  pollfish: {
    id: `${scope}.pollfish`,
    defaultMessage: 'Pollfish page',
  },
  results: {
    id: `${scope}.results`,
    defaultMessage: 'Results page',
  },
  custom: {
    id: `${scope}.custom`,
    defaultMessage: 'Custom redirect URLs',
  },
  prodege: {
    id: `${scope}.prodege`,
    defaultMessage: 'Prodege panel',
  },
});
